import actions from "./extractActions";
import getters from "./extractGetters";
import mutations from "./extractMutations";
import state from "./extractState";

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
};
